export default __webpack_public_path__ + "static/media/Hyrmax_hero.58c4daf4.jpg";